import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight, Sparkles } from 'lucide-react';
import { useOutfitStore } from '@/stores/outfitStore';

interface PlannerFABProps {
  totalDays: number;
  onOpenSheet: () => void;
}

export const PlannerFAB: React.FC<PlannerFABProps> = ({ totalDays, onOpenSheet }) => {
  const { t } = useTranslation();
  const { currentDay, setCurrentDay } = useOutfitStore();

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center gap-2 px-4 py-2.5">
        <button
          onClick={() => currentDay > 1 && setCurrentDay(currentDay - 1)}
          disabled={currentDay === 1}
          aria-label={t('common.previousDay')}
          className="min-w-[44px] h-11 rounded-full bg-secondary text-primary flex items-center justify-center disabled:opacity-40 active:scale-90 transition-all focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:outline-none"
        >
          <ChevronLeft className="w-5 h-5" aria-hidden="true" />
        </button>

        <button
          onClick={onOpenSheet}
          aria-label={t('common.openStyleExport')}
          className="flex-1 h-11 rounded-full bg-gradient-to-r from-[#E91E8C] to-primary text-white font-bold text-sm flex items-center justify-center gap-2 shadow-lg shadow-primary/25 active:scale-95 transition-all focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:outline-none"
        >
          <Sparkles className="w-4 h-4" aria-hidden="true" />
          {t('export.styleTitle')}
        </button>

        <button
          onClick={() => currentDay < totalDays && setCurrentDay(currentDay + 1)}
          disabled={currentDay === totalDays}
          aria-label={t('common.nextDay')}
          className="min-w-[44px] h-11 rounded-full bg-secondary text-primary flex items-center justify-center disabled:opacity-40 active:scale-90 transition-all focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:outline-none"
        >
          <ChevronRight className="w-5 h-5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};
